import type { PrepaySelectData, PrepaySelectHandlers } from '@ctct/application-layer';
import { PrepaySelect } from '@ctct/payflow-ui';
import type { PrepaySelectHooks } from '@ctct/state-client-layer';

interface Props {
  data: PrepaySelectData;
  handlers: PrepaySelectHandlers;
  hooks: PrepaySelectHooks;
  isSingleBillChildAccount?: boolean;
}

export const PrepaySelectWidgetContent = ({ data, handlers, hooks, isSingleBillChildAccount }: Props) => {
  const disabled = Boolean(hooks.useDisabled() || isSingleBillChildAccount);
  const prepay = hooks.usePrepay();

  const periodOptions = data.getPeriodOptions();

  return (
    <PrepaySelect
      periods={periodOptions}
      selectedPeriodId={prepay}
      onPeriodSelect={handlers.onPrepayChange}
      disabled={disabled}
    />
  );
};
